// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_cont {
  display: flex;
  justify-content: space-between;
  height: 100%;
}

.right_cont {
  max-width: 80%;
  /* padding: 0 30px; */
  width: 100%;
}
.right_banner_banner_cnt {
  padding: 0 30px;
}
.right_banner_cont {
  margin: 0 -20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.banner_box {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  height: 350px;
  position: relative;
  z-index: 1;
  display: block;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.banner_box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner_overlay {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  margin: auto;
  background: rgba(255, 255, 255, 0.7);
  padding: 10px;
  font-size: 38px;
  color: #111;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  /* z-index: -1; */
}

.right_inner_inner_banner {
  margin-bottom: 30px;
  /* overflow: hidden; */
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.right_innrBanner:last-child .banner_overlay {
  background: #fff;
  width: 300px;
  height: 300px;
  right: -90px;
  bottom: -90px;
  transform: translate(0) rotate(-45deg);
  border-radius: 100%;
  padding-top: 50px;
  color: #008eda;
  font-size: 46px;
  line-height: 45px;
  font-weight: 600;
  display: none;
}

.right_innrBanner:last-child .banner_overlay:before {
  content: "";
  width: 0;
  height: 0;
  border-top: 30px solid transparent;
  border-bottom: 30px solid transparent;
  border-right: 30px solid #fff;
  position: absolute;
  top: -39px;
  right: 112px;
  /* transform: rotate(200deg);
    -webkit-transform: rotate(200deg); */
  animation: mover 1s infinite alternate;
  /* transition: all 0.3s ease-in-out; */
}

.banner_overlay1 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  margin: auto;
  background: rgba(255, 255, 255, 0.7);
  padding: 10px;
  font-size: 38px;
  color: #111;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
}
.banner_small_text {
  font-size: 20px;
  text-transform: none;
}
@keyframes mover {
  0% {
    transform: translateY(0) rotate(97deg);
  }
  100% {
    transform: translateY(10px) rotate(97deg);
  }
}
._loading_overlay_overlay {
  position: fixed;
  top: 0;
  left: 0;
}
@media screen and (max-width: 1199px) {
  .right_cont {
    max-width: 70%;
  }
  .banner_overlay {
    font-size: 32px;
  }
  .right_innrBanner:last-child .banner_overlay {
    font-size: 32px;
    width: 255px;
    height: 255px;
  }
}

@media screen and (max-width: 767px) {
  .right_cont {
    max-width: 100%;
    margin-top: 40px;
  }
  .main_cont {
    flex-wrap: wrap;
  }
}

/* @media screen and (max-width:480px){
    .header_partttss{
        padding: 10px;
    }
} */

@media screen and (max-width: 420px) {
  .banner_overlay {
    font-size: 28px;
  }
  .banner_box {
    height: 300px;
  }
  .right_innrBanner:last-child .banner_overlay {
    padding-top: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard-member.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ;wCACsC;EAEtC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AAUA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,yCAAyC;EAC3C;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;AACT;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;;;;GAIG;;AAEH;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".main_cont {\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.right_cont {\n  max-width: 80%;\n  /* padding: 0 30px; */\n  width: 100%;\n}\n.right_banner_banner_cnt {\n  padding: 0 30px;\n}\n.right_banner_cont {\n  margin: 0 -20px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.banner_box {\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n  height: 350px;\n  position: relative;\n  z-index: 1;\n  display: block;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n}\n.banner_box img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.banner_overlay {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n  margin: auto;\n  background: rgba(255, 255, 255, 0.7);\n  padding: 10px;\n  font-size: 38px;\n  color: #111;\n  font-weight: 500;\n  text-transform: uppercase;\n  text-align: center;\n  /* z-index: -1; */\n}\n\n.right_inner_inner_banner {\n  margin-bottom: 30px;\n  /* overflow: hidden; */\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.right_innrBanner:last-child .banner_overlay {\n  background: #fff;\n  width: 300px;\n  height: 300px;\n  right: -90px;\n  bottom: -90px;\n  transform: translate(0) rotate(-45deg);\n  border-radius: 100%;\n  padding-top: 50px;\n  color: #008eda;\n  font-size: 46px;\n  line-height: 45px;\n  font-weight: 600;\n  display: none;\n}\n\n.right_innrBanner:last-child .banner_overlay:before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 30px solid transparent;\n  border-bottom: 30px solid transparent;\n  border-right: 30px solid #fff;\n  position: absolute;\n  top: -39px;\n  right: 112px;\n  /* transform: rotate(200deg);\n    -webkit-transform: rotate(200deg); */\n  -webkit-animation: mover 1s infinite alternate;\n  animation: mover 1s infinite alternate;\n  /* transition: all 0.3s ease-in-out; */\n}\n\n.banner_overlay1 {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n  margin: auto;\n  background: rgba(255, 255, 255, 0.7);\n  padding: 10px;\n  font-size: 38px;\n  color: #111;\n  font-weight: 500;\n  text-transform: uppercase;\n  text-align: center;\n}\n.banner_small_text {\n  font-size: 20px;\n  text-transform: none;\n}\n\n@-webkit-keyframes mover {\n  0% {\n    transform: translateY(0) rotate(97deg);\n  }\n  100% {\n    transform: translateY(10px) rotate(97deg);\n  }\n}\n@keyframes mover {\n  0% {\n    transform: translateY(0) rotate(97deg);\n  }\n  100% {\n    transform: translateY(10px) rotate(97deg);\n  }\n}\n._loading_overlay_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n@media screen and (max-width: 1199px) {\n  .right_cont {\n    max-width: 70%;\n  }\n  .banner_overlay {\n    font-size: 32px;\n  }\n  .right_innrBanner:last-child .banner_overlay {\n    font-size: 32px;\n    width: 255px;\n    height: 255px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .right_cont {\n    max-width: 100%;\n    margin-top: 40px;\n  }\n  .main_cont {\n    flex-wrap: wrap;\n  }\n}\n\n/* @media screen and (max-width:480px){\n    .header_partttss{\n        padding: 10px;\n    }\n} */\n\n@media screen and (max-width: 420px) {\n  .banner_overlay {\n    font-size: 28px;\n  }\n  .banner_box {\n    height: 300px;\n  }\n  .right_innrBanner:last-child .banner_overlay {\n    padding-top: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
